


































import Vue from 'vue';
import { BAlert, BButton, BFormInput } from 'bootstrap-vue';
import { ZenFormGroup } from 'zenComponents';

import { ModalSize } from '@/components/zen_modal/types';
import { saveBookmark, removeBookmark } from '@/utils/crudActions';
import { getQueryParams, setQueryParams, redirect, reload } from '@/utils';
import { ApiError } from './types';
import GenericCard from './GenericCard.vue';

import 'url-search-params-polyfill';

export default Vue.extend({
  name: 'BookmarkCard',
  components: {
    BAlert,
    BButton,
    ZenFormGroup,
    BFormInput,
    GenericCard,
  },
  props: {
    csrfToken: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    preventRedirect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputText: <string>this.title,
      error: <ApiError | null>null,
    };
  },
  computed: {
    editing(): boolean {
      return this.id !== null;
    },
    modalTexts() {
      if (this.editing) {
        return { title: 'Rename favorite', button: 'Rename' };
      } else {
        return { title: 'Add to favorites', button: 'Save' };
      }
    },
    modalTitleText(): string {
      return this.id ? 'Rename favorite' : 'Add to favorites';
    },
    inputEmpty(): boolean {
      return this.inputText.trim().length === 0;
    },
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Small });
  },
  methods: {
    async save() {
      if (this.inputEmpty) return;

      try {
        const response = await saveBookmark({
          csrf: this.csrfToken,
          id: this.id,
          link: window.location.pathname + window.location.search,
          title: this.inputText.trim(),
        });
        if (this.preventRedirect) {
          this.$store.dispatch('modals/confirm', { state: 'SAVED', data: response });
          return;
        }
        this.redirect(response.redirectUrl);
        this.$emit('close');
      } catch (error) {
        this.error = error;
      }
    },
    async remove() {
      try {
        await removeBookmark({
          csrf: this.csrfToken,
          id: this.id,
        });
        if (this.preventRedirect) {
          this.$store.dispatch('modals/confirm', { state: 'DELETED' });
          return;
        }
        const newParams = new URLSearchParams(this.getQueryParams());
        newParams.delete('bookmark');
        this.setQueryParams(newParams.toString());
        this.reload();
      } catch (error) {
        this.error = error;
      }
    },
    getQueryParams,
    setQueryParams,
    redirect,
    reload,
  },
});
